<template>
	<div class="reserve-background-width" style="max-width: 100% !important;  height: 100vh; width:1080px; overflow:auto; min-width:1080px;">
		<div v-if="step === '1'">
			<v-img
				v-if="eventsData.eventImg"
				:src="$store.state.frontServer_upload + eventsData.eventImg.url"
				@error="imgError()"
				@click="startEvent()"
			></v-img>
			<!-- 메인 이미지 미등록 시 기본 인트로 화면 -->
			<div v-else class="triven-intro" @click="startEvent()">
				<div class="triven-intro-site">트리븐 센텀</div>
				<div class="triven-intro-title">방문고객 경품추첨 EVENT</div>
				<div class="triven-intro-desc">이름과 연락처를 입력하고<br />응모권을 받아 응모함에 넣어주세요.</div>
				<div class="triven-intro-btn">응모하기 &#8250;</div>
			</div>
		</div>
		<div v-show="step === '3'">
			<main class="content_step2">
				<!-- 개인정보 수집 · 이용 및 처리 위탁 동의 (트리븐 센텀 약관) -->
				<section class="info-section raon-terms">
					<section class="info-header"><span class="mr-2">|</span> 개인정보 수집 · 이용 동의 <span class="ml-2">|</span></section>
					<div class="triven-terms-box">
						<div v-for="(sec, i) in privacyTerms" :key="i" class="triven-terms-sec">
							<div class="triven-terms-h">{{ sec.title }}</div>
							<p v-for="(line, j) in sec.lines" :key="j" :class="{ 'triven-terms-sub': line.startsWith('(') }">{{ line }}</p>
						</div>
					</div>
					<div class="raon-terms-agree">
						<span class="raon-terms-q">위와 같이 개인정보 수집 · 이용 및 처리 위탁에 동의하십니까?</span>
						<span class="terms-radio-option" @click="privacyAgree = true">
							<span class="terms-radio" :class="{ active: privacyAgree }">{{ privacyAgree ? '◉' : '○' }}</span> 동의 함
						</span>
						<span class="terms-radio-option" @click="privacyAgree = false">
							<span class="terms-radio" :class="{ active: !privacyAgree }">{{ !privacyAgree ? '◉' : '○' }}</span> 동의 안함
						</span>
					</div>
				</section>
				<section class="info-section">
					<section class="info-header"><span class="mr-2">|</span> 기본 정보 입력 <span class="ml-2">|</span></section>

					<div class="info-form">
						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">이 름</label>
								<v-flex xs12>
									<txtField class="placeholder-color-white font-size-30" :txtField="nametxtField" v-model="nametxtField.value"></txtField>
								</v-flex>
							</v-layout>
						</div>

						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">전화번호</label>
								<v-layout wrap>
									<v-flex xs2>
										<select-box :sel="numSel" @change="change"></select-box>
									</v-flex>
									<v-flex xs10 class="pl-1">
										<txtField class="placeholder-color-white font-size-30" :txtField="numtxtField" v-model="numtxtField.value"></txtField>
									</v-flex>
								</v-layout>
							</v-layout>
						</div>

						<v-flex xs12>
							<v-layout wrap class="mt-4 keypad_background">
								<v-flex xs9>
									<keyboard_kr @onChange="onChange_kr" @onKeyPress="onKeyPress_kr" :input="nametxtField.value" />
								</v-flex>
								<v-flex xs3 class="pl-3">
									<keyboard_number @onChange="onChange_number" :input="numtxtField.value" />
								</v-flex>
							</v-layout>
						</v-flex>
					</div>
				</section>
				<section class="info-desc">
					<div class="next-button-container">
						<button class="action-button-outlined mr-4" @click="cancelToMain()">처음으로</button>
						<div class="nextButton_css" @click="submitForm">
							<span class="text">응모하기</span>
							<span class="arrow">&#8250;</span>
						</div>
					</div>
				</section>
			</main>
		</div>
		<!-- 응모권 발급 안내 → 출력 -->
		<v-dialog v-model="ticketDialog" width="80%" persistent content-class="check_dialog">
			<div class="triven-result">
				<div class="triven-result-title">응모권이 발급되었습니다!</div>
				<div class="triven-result-info">{{ nametxtField.value }} 고객님 · {{ phoneFormat() }}</div>
				<div class="triven-result-desc">응모권을 출력해 응모함에 넣어주세요.<br />추첨은 정해진 시간에 진행됩니다.</div>
				<v-btn :color="btnColor || '#000E43'" x-large dark @click="print()" block style="font-size: 36px;" height="80">
					응모권 출력
				</v-btn>
			</div>
		</v-dialog>
		<!-- 응모권 인쇄 영역 : 79x140mm 1장 (이름 / 전화번호 전체 표시) -->
		<div id="print-background-triven">
			<!-- 79x140mm 1장 고정 (브라우저 iframe / Electron 인쇄창 모두 이 스타일을 그대로 가져간다) -->
			<component :is="'style'">
				@page { size: 79mm 140mm; margin: 0; } html, body { margin: 0; padding: 0; }
			</component>
			<div
				style="width: 79mm; height: 140mm; box-sizing: border-box; padding: 8mm 5mm; overflow: hidden; page-break-after: avoid; page-break-inside: avoid; background-color: #ffffff; color: #000000; text-align: center; font-family: 'Noto Sans KR', Arial, sans-serif; display: flex; flex-direction: column;"
			>
				<div style="font-size: 6mm; font-weight: 900; line-height: 1.3;">트리븐 센텀</div>
				<div style="font-size: 5mm; font-weight: 700; line-height: 1.3; margin-top: 1mm;">방문고객 경품추첨 응모권</div>
				<div style="border-top: 0.4mm solid #000; margin: 5mm 0 0;"></div>
				<div style="flex: 1; display: flex; flex-direction: column; justify-content: center;">
					<div style="font-size: 4mm; font-weight: 700; color: #000;">성명</div>
					<div style="font-size: 9mm; font-weight: 900; line-height: 1.2; word-break: keep-all;">{{ nametxtField.value }}</div>
					<div style="font-size: 4mm; font-weight: 700; margin-top: 5mm;">연락처</div>
					<div style="font-size: 8mm; font-weight: 900; line-height: 1.2;">{{ phoneFormat() }}</div>
					<div style="font-size: 3.6mm; font-weight: 700; margin-top: 6mm;">응모번호 {{ eventJoinId }}</div>
					<div style="font-size: 3.6mm; font-weight: 700; margin-top: 1mm;">({{ new Date() | moment('YYYY-MM-DD HH:mm') }})</div>
				</div>
				<div style="border-top: 0.4mm solid #000; margin-bottom: 3mm;"></div>
				<div style="font-size: 3.2mm; font-weight: 700; text-align: left; line-height: 1.5;">
					<div>※ 본 응모권을 응모함에 넣어주세요.</div>
					<div>※ 추첨은 정해진 시간에 진행됩니다.</div>
					<div>※ 성명, 연락처 불일치 시 경품 지급이 불가합니다.</div>
					<div>※ 1인 1경품 수령을 원칙으로 합니다.</div>
				</div>
			</div>
		</div>
		<alertModal5 :setdialog="alertModal" />
	</div>
</template>

<script>
import { alertModal5, keyboard_kr, keyboard_number, selectBox, txtField } from '@/components/index.js'
import Hangul from 'hangul-js'
// 트리븐 센텀 방문고객 경품추첨 키오스크 (triven1~3)
// 이름 / 전화번호 입력 + 개인정보 동의 → 인증번호 없이 바로 응모 → 당첨(응모권) 시 응모권 출력 (룰렛 없음)
export default {
	components: {
		txtField,
		selectBox,
		keyboard_kr,
		keyboard_number,
		alertModal5,
	},
	metaInfo() {
		return {
			title: this.campaignTitle,
		}
	},
	data() {
		return {
			privacyAgree: true,
			privacyTerms: [
				{
					title: '1. 개인정보의 수집 및 이용 목적',
					lines: ['트리븐센텀은 고객님에게 다양한 정보안내를 위하여 필요한 최소한의 범위 내에서 개인정보를 수집하고 있습니다.'],
				},
				{
					title: '2. 개인정보의 수집 및 이용에 관한 동의',
					lines: [
						'- 수집주체 : 트리븐센텀 (분양대행 : (주)와이지컴퍼니)',
						'- 수집항목 : 성명, 연락처, 관심 타입, 청약통장 가입유무, 연령, 성별, 지역',
						'- 개인정보 수집방법 : 홈페이지 관심고객등록, 이벤트 응모 등',
						'- 보유기간 : 분양종료 시까지',
						'- 자동생성 수집항목 : 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보, 불량이용 기록, 기기정보 등',
						'귀하는 개인정보 수집·이용에 관한 동의를 거부할 권리가 있으며, 동의를 거부할 경우 관심고객등록이 제한됩니다.',
					],
				},
				{
					title: '3. 개인정보의 수집 및 이용 목적',
					lines: [
						'수집한 개인정보는 다음의 목적으로 이용합니다.',
						'- 트리븐 센텀 분양정보 안내 및 분양상담',
						'- 회사가 분양하는 사업지에 대한 온·오프라인 분양 마케팅 및 광고 활동',
						'- 마케팅 및 광고에 활용, 신규 서비스 개발 및 특화, 이벤트 등 광고성 정보 전달',
						'- 관심 타입, 청약통장 가입유무, 연령, 성별, 지역 등 고객 특성에 따른 서비스 제공 및 고객 수요 분석',
						'- 접속빈도 파악, 방문자 통계 분석, 중복 등록 확인 및 서비스 이용에 대한 통계',
					],
				},
				{
					title: '4. 개인정보의 보유 및 이용기간',
					lines: [
						'- 개인정보는 트리븐 센텀 분양종료 시까지 보유하며, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.',
						'- 단, 관계 법령의 규정에 따라 보존할 필요가 있는 경우에는 해당 법령에서 정한 기간 동안 보관할 수 있습니다.',
					],
				},
				{
					title: '5. 개인정보 수집 및 이용에 대한 동의 거부 권리',
					lines: [
						'- 고객께서는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 다만, 동의하지 않을 경우 관심고객등록이 불가합니다.',
					],
				},
				{
					title: '6. 개인정보 처리 위탁에 대한 동의',
					lines: [
						'(1) 개인정보 처리 위탁',
						'서비스 이행을 위하여 개인정보 처리업무를 아래와 같이 외부 전문업체에 위탁하여 운영하고 있습니다.',
						'(2) 위탁 대상자',
						'- 시행수탁 : (주)하나자산신탁',
						'- 시공 : 두산에너빌리티(주)',
						'- 시행위탁 : (주)정상시티파크',
						'(3) 위탁 업무 내용',
						'- 분양정보 안내 및 이벤트 정보 전달, 분양상담, 고객 응대 등',
						'(4) 위탁 개인정보의 보유 및 이용기간',
						'- 트리븐 센텀 분양완료 시까지 개인정보를 보유하며, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.',
						'- 다만, 고객이 사전에 동의한 경우 또는 관계 법령의 규정에 의거하여 보존할 필요가 있는 경우에는 해당 기간 동안 보관할 수 있습니다.',
						'(5) 개인정보 처리 위탁 동의 거부 권리',
						'- 고객께서는 개인정보 처리 위탁에 대한 동의를 거부할 권리가 있습니다. 다만, 동의하지 않을 경우 관심고객등록이 불가합니다.',
					],
				},
			],
			alertModal: {
				dialog: false,
				text: '',
			},
			numtxtField: {
				height: 50,
				color: 'white',
				label: '전화번호를 입력하세요',
				solo: true,
				dark: false,
				type: 'Number',
				value: '',
				onlyNumber: true,
				maxlength: 8,
				maxNumber: true,
				max: 99999999,
				readonly: true,
			},
			nametxtField: {
				height: 50,
				value: '',
				solo: true,
				readonly: true,
				label: '이름을 입력하세요',
				dark: false,
				color: 'white',
			},
			numSel: {
				value: '010',
				solo: true,
				class: 'selectNum',
				items: ['010', '011', '016', '017'],
				dark: false,
				color: 'white',
				height: 50,
			},
			nameTxtArray: [],
			step: '1',
			eventsData: {},
			code: '',
			winnterProduct: '',
			eventJoinId: '',
			btnColor: '',
			ticketDialog: false,
			campaignTitle: '트리븐 센텀 방문고객 경품추첨',
		}
	},
	async created() {
		// triven1 로 접속하면 행사일(KST)에 맞는 이벤트 코드로 자동 전환 (1일 기준 응모권 수량이라 이벤트를 일자별로 나눠 운영)
		// triven1 은 10/16 까지(사전 테스트 포함), 10/17 → triven2 ... 11/1 → triven17
		const trivenCodeByDate = {}
		for (let n = 2; n <= 17; n++) {
			const date = this.$moment('2026-10-17')
				.add(n - 2, 'days')
				.format('YYYY-MM-DD')
			trivenCodeByDate[date] = 'triven' + n
		}
		const todayKST = this.$moment()
			.utcOffset('+09:00')
			.format('YYYY-MM-DD')
		if (this.$route.params.code === 'triven1' && trivenCodeByDate[todayKST]) {
			this.code = trivenCodeByDate[todayKST]
		} else {
			this.code = this.$route.params.code
		}
		await this.events()
	},
	methods: {
		// 010-1234-5678 형식 (응모권에는 전화번호 전체 표시)
		phoneFormat() {
			const num = this.numtxtField.value
			return `${this.numSel.value}-${num.slice(0, num.length - 4)}-${num.slice(-4)}`
		},
		print() {
			// 응모권 1장 인쇄
			const ticket = document.getElementById('print-background-triven').innerHTML
			this.ticketDialog = false
			if (process.env.IS_ELECTRON) {
				const { ipcRenderer } = window.require('electron')
				ipcRenderer.send('print-document', ticket)
			} else {
				this.printHtml(ticket)
			}
			setTimeout(() => {
				this.resetForm()
			}, 2000)
			return false
		},
		// 단일 응모권 HTML을 숨김 iframe으로 인쇄
		printHtml(printContent) {
			const printFrame = document.createElement('iframe')
			printFrame.style.position = 'fixed'
			printFrame.style.right = '0'
			printFrame.style.bottom = '0'
			printFrame.style.width = '0'
			printFrame.style.height = '0'
			printFrame.style.border = '0'
			document.body.appendChild(printFrame)
			const frameDoc = printFrame.contentWindow.document
			frameDoc.open()
			frameDoc.write(`
    <html>
      <head>
        <style>
          @page {
            size: 79mm 140mm; /* 응모권 1장 크기 */
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>${printContent}</body>
    </html>
  `)
			frameDoc.close()
			printFrame.contentWindow.focus()
			setTimeout(() => {
				printFrame.contentWindow.print()
				setTimeout(() => {
					document.body.removeChild(printFrame)
				}, 1000)
			}, 500)
		},
		// 입력값 초기화 후 첫 화면으로
		resetForm() {
			this.numSel.value = '010'
			this.numtxtField.value = ''
			this.nametxtField.value = ''
			this.nameTxtArray = []
			this.privacyAgree = true
			this.winnterProduct = ''
			this.eventJoinId = ''
			this.step = '1'
			this.$store.state.loading = false
		},
		cancelToMain() {
			this.resetForm()
		},
		createEventJoin() {
			this.$store.state.loading = true
			let data2 = {
				name: this.nametxtField.value,
				phone: this.numSel.value + this.numtxtField.value,
				code: this.code,
				marketing: this.privacyAgree,
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			this.$store
				.dispatch('createEventJoin', data2)
				.then(res => {
					const join = res.data.createEventJoin.eventJoin
					this.$store.state.loading = false
					if (join.name === '이벤트 종료') {
						this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
						this.alertModal.dialog = true
						this.resetForm()
					} else if (join.name === '중복번호') {
						this.alertModal.text = '오늘 이미 응모하신 번호입니다.'
						this.alertModal.dialog = true
					} else if (join.winnterProduct) {
						// 응모권 당첨 → 발급 안내 후 출력
						this.winnterProduct = join.winnterProduct
						this.eventJoinId = join.id
						this.ticketDialog = true
					} else {
						// 미당첨
						this.alertModal.text = this.eventsData.joinMessage || '아쉽게도 당첨되지 않았습니다.'
						this.alertModal.dialog = true
						this.resetForm()
					}
				})
				.catch(err => {
					// 서버가 id 없는 응답(중복번호/이벤트 종료)을 주면 GraphQL 오류로 떨어진다 → 로딩 해제 후 안내
					console.log({ err })
					this.$store.state.loading = false
					this.alertModal.text = '이미 참여하셨거나 이벤트가 종료되어 참여할 수 없습니다.'
					this.alertModal.dialog = true
					this.resetForm()
				})
		},
		async eventJoinsConnection() {
			await this.$store.dispatch('eventJoinsConnection', { code: this.code }).then(res => {
				if (this.eventsData.maxcount < res.data.eventJoinsConnection.aggregate.count) {
					this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					return (this.alertModal.dialog = true)
				}
			})
		},
		async events() {
			this.$store.state.loading = true
			await this.$store
				.dispatch('events', { code: this.code })
				.then(res => {
					if (res.data.events.length === 0) {
						this.$router.push({ name: 'notfound' })
					}
					this.eventsData = res.data.events[0]
					this.$store.state.loading = false
					this.eventJoinsConnection()
					if (this.eventsData.business) {
						this.btnColor = this.eventsData.business.color
					}
				})
				.catch(err => {
					console.log(err)
				})
		},
		change() {
			return {}
		},
		submitForm() {
			if (!this.nametxtField.value) {
				this.alertModal.text = '이름을 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.numtxtField.value) {
				this.alertModal.text = '전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (this.numtxtField.value.length < 7) {
				this.alertModal.text = '올바른 전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.privacyAgree) {
				this.alertModal.text = '개인정보 수집 · 이용 및 처리 위탁에 동의해주세요.'
				return (this.alertModal.dialog = true)
			}
			// 인증번호 없이 바로 응모
			this.createEventJoin()
		},
		startEvent() {
			if (this.step !== '1') return
			// 서버로부터 받은 이벤트 시작/종료 날짜를 한국 시간으로 변환
			const startDate = this.$moment(this.eventsData.start).utcOffset('+09:00')
			const endDate = this.$moment(this.eventsData.end).utcOffset('+09:00')
			const currentDate = this.$moment().utcOffset('+09:00')
			if (currentDate.isBefore(startDate)) {
				this.alertModal.text = '이벤트가 아직 시작되지 않았습니다.'
				return (this.alertModal.dialog = true)
			}
			if (currentDate.isAfter(endDate)) {
				this.alertModal.text = '이벤트가 종료되었습니다.'
				return (this.alertModal.dialog = true)
			}
			this.eventJoinsConnection()
			this.step = '3'
		},
		onChange_kr() {
			this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
		},
		onKeyPress_kr(button) {
			if (button === '{retry}') {
				this.nametxtField.value = ''
				this.nameTxtArray = []
			} else {
				if (button !== '{bksp}') {
					this.nameTxtArray.push(button)
				} else {
					if (this.nameTxtArray.length > 0) {
						this.nameTxtArray.splice([this.nameTxtArray.length - 1], 1)
						this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
					}
				}
			}
		},
		onChange_number(input) {
			if (input.length < 9) this.numtxtField.value = input
		},
		imgError() {
			this.eventsData.eventImg = null
		},
	},
}
</script>

<style lang="scss">
@page {
	size: auto; /* auto is the initial value */
	margin: 5mm; /* this affects the margin in the printer settings */
}

#print-background {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
#print {
	display: none;
}
.check_re_btn {
	width: 200px !important;
	height: 45px !important;
}
.check_complete {
	width: 200px !important;
	height: 45px !important;
}
.infoBackground {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	min-width: 90px;
	min-height: 90px;
	margin-bottom: 10px;
	.infoYear {
		background-color: white;
		color: black;
		font-size: 14px;
		border-radius: 10px 10px 0px 0px;
	}
	.infoHour {
		font-size: 14px;
		font-weight: 100;
	}
}
.v-dialog:not(.v-dialog--fullscreen) {
	max-height: 95% !important;
}
.check_dialog {
	padding: 20px;
	background-color: #ececec;
	.check_layout {
		background-color: white;
		border-radius: 10px;
		padding: 20px;
		.check_sub_layout {
			padding-left: 100px;
		}
		.check_title {
			text-align: center;
			font-size: 47px;
			font-weight: bold;
			color: #631115;
		}
		.check_sub_title {
			font-size: 18px;
			font-weight: bold;
			color: #631115;
		}
		.check_info {
			font-size: 17px;
			padding-left: 35px;
			color: #707070;
		}
	}
}
.radio_label_white {
	label {
		color: white !important;
	}
}
.keypad_btn {
	width: 230px;
	height: 69px !important;
	background-color: white !important;
	font-weight: bold !important;
	border-radius: 15px !important;
	font-size: 26px !important;
}
.keypad_background {
	background-color: rgba(255, 255, 255, 0.43);
	border-radius: 18px;
	padding: 8px;
}

.placeholder-color-white {
	.v-input__control {
		.v-input__slot {
			.v-text-field__slot {
				input {
					font-size: 28px !important;
				}
			}
		}
	}
}
.selectNum {
	.v-select__selection {
		font-size: 20px !important;
	}
	input {
		font-size: 20px !important;
	}
}
.keypad_agree_content {
	border: 1px solid;
	border-color: rgba(255, 255, 255, 0.5);
	border-radius: 15px;
	white-space: break-spaces;
	color: white;
	font-size: 11px;
	padding: 8px;
	text-align: left;
	height: auto;
	max-height: 276px;
	overflow: auto;
}
.reserve_keypad_maintxt {
	font-size: 24px;
	font-weight: bold;
	color: white;
}
.reserve_keypad_subtxt {
	font-size: 20px;
	color: white;
}
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}

.startVisit {
	background: white !important;
	padding: 20px 0px;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
.dialogBottom {
	.title {
		height: 50px;
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #fdc85a;
		padding: 0 10px 0 30px;

		h2 {
			color: white;
			font-weight: bold;
			font-size: 18px;
		}

		.title-icon {
			color: white;
		}
	}
	.dialog-content {
		padding: 20px 20px 20px 20px;
	}
}
.hiddenTab {
	display: none;
}

.roullet_dialog.v-dialog {
	overflow: hidden;
	background: transparent;
	box-shadow: none;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}
</style>
<style lang="scss" scoped>
.start-button-group {
	position: absolute !important;
	bottom: 300px;
	display: flex;
	gap: 30px;
	justify-content: center;
	width: 100%;
}
.start-button {
	background-color: #001a43;
	color: #fff;
	padding: 20px 60px;
	font-size: 64px;
	line-height: 64px;
	font-weight: 700;
	border-radius: 100px;
	cursor: pointer;
	box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	-webkit-box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	-moz-box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
	border: 4px solid #f4f3f4;
	outline: 3px solid #f4f3f4;
	outline-offset: -1px;
	width: 450px;
}

.nextButton_css {
	background-color: #001a43;
	color: white;
	border: none;
	border-radius: 80px !important;
	padding: 0 48px !important;
	height: 100px !important;
	font-size: 60px !important;
	font-weight: bold;
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 400px !important;
	justify-content: center;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
	.text {
		margin-right: 18px;
	}
	.arrow {
		font-size: 120px;
		margin-bottom: 28px;
		font-weight: 100;
	}
}
.imageButton {
	height: 100vh;
	.v-responsive__content {
		position: relative;
		.keypad_main_layout {
			padding: 0 28px;
			position: absolute;
			top: 350px;
		}
		.clickBtn {
			position: absolute;
			bottom: 980px;
			width: 100%;
			button {
				height: 120px;
				font-size: 48px;
				font-weight: bold;
				margin: 0 auto;
				min-width: 100px;
				width: 100%;
				max-width: 710px;
				border-radius: 15px;
			}
		}
	}
	text-align: end;
	padding: 20px;
}
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
.duplicateInfo {
	font-size: 15px;
	margin-left: 16px;
	color: #808080;
}
.roullet_div {
	width: 900px;
	padding-top: 80px;
	position: relative;
}
.roullet_board {
	transform: rotate(30deg); /* 360/6/2 */
	width: 100%;
}
.roullet_arrow {
	width: 125px;
	z-index: 1;
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0%);
	top: -10px;
}
#print-background-triven {
	display: none;
}
.event-bottom-img {
	position: absolute;
	bottom: 120px;
}
.next-button-container {
	overflow: hidden;
	display: flex;
	justify-content: center;
	margin: 20px;
	margin-bottom: 40px;
}
.reserve-background-width {
	height: 100vh;
	width: 100%;
	min-width: 900px;
	max-width: 1080px;
	margin: 0 auto;
}
/* step1 */
.content_step1 {
	background-color: #001a43;
	color: white;
	padding: 160px 40px 0px 40px;
	text-align: center;
}

.title-small {
	font-size: 36px;
	margin-bottom: 12px;
}

.title-large {
	font-size: 76px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.2;
}

.divider {
	width: 1px;
	height: 60px;
	background-color: #fff;
	margin: 80px auto;
}

.event-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
}
.event-bottom {
	margin: 0 150px;
}
.event-subtitle {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.3;
}

.prizes-container {
	background-color: white;
	border-radius: 30px;
	padding: 40px;
	margin-bottom: 20px;
	display: flex;
	flex-wrap: wrap;
}

.prize-item {
	width: 50%;
	padding: 20px;
	text-align: center;
}

.prize-rank {
	display: block;
	margin-bottom: 20px;
	width: 120px;
	height: 120px;
}

.prize-image {
	width: 160px;
	height: 160px;
	margin: 0 auto 20px;
}

.prize-name {
	color: #001a43;
	font-weight: bold;
	font-size: 32px;
	margin-bottom: 5px;
}

.prize-desc {
	color: #666;
	font-size: 28px;
}

.footnotes {
	text-align: left;
	color: #aaa;
	font-size: 16px;
	line-height: 1.5;
	white-space: pre-line;
}

/* step2 - terms page */
.content_step2_terms {
	background-color: #ffffff;
	height: 1920px;
	padding: 40px 60px 20px 60px;
	color: #2a3754;
	font-family: 'Noto Sans KR', sans-serif;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.terms-wrapper {
	width: 100%;
	max-width: 980px;
	margin: 0 auto;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.terms-title {
	font-size: 44px;
	font-weight: bold;
	color: #2a3754;
	border-bottom: 2px solid #2a3754;
	padding-bottom: 12px;
	margin: 0 0 14px;
	letter-spacing: -1px;
}

.terms-subtitle {
	font-size: 22px;
	color: #2a3754;
	margin-bottom: 22px;
	line-height: 1.4;
}

.terms-body {
	padding-left: 50px;

	p {
		margin: 0 0 2px;
		font-size: 20px;
		line-height: 1.5;
		color: #333;
	}
}

.terms-section {
	font-size: 26px;
	font-weight: bold;
	margin: 18px 0 8px;
	color: #2a3754;
	letter-spacing: -1px;
}

.terms-subsection {
	font-size: 22px !important;
	font-weight: bold;
	margin-top: 14px !important;
	margin-bottom: 4px !important;
	color: #2a3754 !important;
}

.terms-trustee-list {
	margin: 8px 0 8px;

	.terms-trustee-row {
		display: flex;
		padding: 3px 0;
		font-size: 20px;
		color: #333;

		span:first-child {
			width: 300px;
			flex-shrink: 0;
		}
	}

	.terms-trustee-header {
		font-weight: bold;
		color: #2a3754;
	}
}

.terms-agreement-table {
	width: 100%;
	border-collapse: collapse;
	border-top: 2px solid #2a3754;
	border-bottom: 2px solid #2a3754;
	margin: 8px 0 12px;
	font-size: 18px;

	th,
	td {
		padding: 8px 12px;
		border-bottom: 1px solid #d0d0d0;
		text-align: left;
		vertical-align: middle;
		color: #333;
		line-height: 1.4;
	}

	th {
		font-weight: bold;
		border-bottom: 1px solid #2a3754;
		text-align: center;
		color: #2a3754;
		background-color: #fafafa;
		padding: 8px 12px;
	}

	.col-type {
		text-align: center;
		font-weight: bold;
		width: 80px;
	}

	.col-content {
		line-height: 1.4;
	}

	.col-agree {
		width: 220px;
		white-space: nowrap;
	}

	.col-name {
		width: 100px;
	}
}

.terms-radio-option {
	cursor: pointer;
	margin-right: 12px;
	color: #2a3754;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 18px;

	.terms-radio {
		color: #2a3754;
		font-size: 17px;

		&.active {
			color: #1d3a6e;
			font-weight: bold;
		}
	}
}

.terms-notice {
	font-size: 19px !important;
	margin-top: 3px !important;
	color: #333 !important;
	font-weight: 500;
}

.terms-footnotes {
	margin-top: 12px;

	.terms-footnote {
		font-size: 15px !important;
		color: #555 !important;
		margin: 3px 0 !important;
		line-height: 1.45;
	}

	.terms-footnote-bold {
		font-size: 16px !important;
		color: #333 !important;
		margin: 8px 0 2px !important;
		font-weight: bold;
	}

	.terms-footnote-indent {
		font-size: 15px !important;
		padding-left: 14px;
		color: #555 !important;
		margin: 2px 0 !important;
		line-height: 1.45;
	}
}

.terms-final-notice {
	margin-top: 12px;

	p {
		font-size: 17px;
		margin: 3px 0;
		color: #2a3754;
		line-height: 1.45;
	}
}

.terms-button-container {
	display: flex;
	justify-content: center;
	margin-top: 16px;
	padding-top: 20px;
	padding-bottom: 6px;
}

.terms-next-button {
	background-color: #1d3a6e;
	color: white;
	border: none;
	border-radius: 60px;
	padding: 0 70px;
	height: 84px;
	font-size: 40px;
	font-weight: bold;
	cursor: pointer;
	min-width: 380px;
	letter-spacing: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 개인정보 수집 및 이용 동의 (step3) */
.privacy-info-section {
	margin-top: 24px;
	padding: 0 40px;
}

.privacy-info-title {
	font-size: 28px;
	font-weight: bold;
	color: #001a43;
	margin-bottom: 8px;
	letter-spacing: -1px;
}

.privacy-info-table {
	width: 100%;
	border-collapse: collapse;
	border-top: 2px solid #001a43;
	border-bottom: 2px solid #001a43;
	font-size: 18px;
	background-color: #ffffff;
}

.privacy-info-table th,
.privacy-info-table td {
	padding: 10px 14px;
	border: 1px solid #c8c8c8;
	line-height: 1.5;
	vertical-align: middle;
	color: #333;
}

.privacy-info-table th {
	background-color: #f0f0f0;
	color: #001a43;
	font-weight: bold;
	text-align: center;
	width: 220px;
	white-space: nowrap;
}

/* 거주지역 입력 행 */
.address-display {
	width: 100%;
	min-height: 60px;
	background-color: white;
	color: #001a43;
	border-radius: 4px;
	padding: 12px 20px;
	font-size: 28px;
	display: flex;
	align-items: center;
}

.address-select-btn {
	width: 100%;
	height: 70px;
	background-color: #ffffff;
	color: #001a43;
	border: 2px solid #001a43;
	border-radius: 12px;
	font-size: 24px;
	font-weight: bold;
	cursor: pointer;
	line-height: 1.1;
}

/* 주소 선택 다이얼로그 */
.address-dialog {
	background-color: #f3efe6;
	border-radius: 16px;
	padding: 0;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
	overflow: hidden;
}

.address-dialog-content {
	background-color: #f3efe6;
	padding: 36px 32px 40px;
	position: relative;
}

.address-close-btn {
	position: absolute;
	top: 18px;
	left: 18px;
	width: 36px;
	height: 36px;
	background-color: #001a43;
	color: white;
	border: none;
	border-radius: 50%;
	font-size: 18px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.address-dialog-title {
	text-align: center;
	font-size: 32px;
	font-weight: bold;
	color: #001a43;
	margin-bottom: 6px;
}

.address-dialog-step {
	font-size: 22px;
	color: #777;
	font-weight: normal;
}

.address-dialog-subtitle {
	text-align: center;
	font-size: 22px;
	color: #001a43;
	margin-bottom: 24px;
	border-bottom: 1.5px solid #001a43;
	padding-bottom: 14px;
}

.address-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 10px;
	max-height: 70vh;
	overflow-y: auto;
}

.address-grid-btn {
	background-color: #ffffff;
	color: #001a43;
	border: 1.5px solid #001a43;
	border-radius: 10px;
	padding: 14px 6px;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	min-height: 56px;
	transition: all 0.15s ease;
	line-height: 1.2;
}

.address-grid-btn:hover {
	background-color: #001a43;
	color: white;
}

.address-grid-btn.active {
	background-color: #001a43;
	color: white;
	border-color: #001a43;
}

/* 지역/관할구 선택 버튼 */
.age-button-group {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
.age-button {
	flex: 1 1 0;
	min-width: 90px;
	background-color: #ffffff;
	color: #001a43;
	border: 2px solid #ffffff;
	border-radius: 10px;
	padding: 10px 4px;
	font-size: 26px;
	font-weight: 700;
	cursor: pointer;
	min-height: 56px;
	transition: all 0.15s ease;
	line-height: 1.2;
}
.age-button.active {
	background-color: #ff6b00;
	color: #ffffff;
	border-color: #ff6b00;
}

/* step2 */
.content_step2 {
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	min-height: 100vh;
	overflow: visible;
	padding: 20px 40px 20px 40px;
	color: #001a43;
}
.info-section {
	padding: 0px 40px 0px 40px;
}

.info-header {
	color: black;
	letter-spacing: -4px;
	font-size: 48px;
	font-weight: bold;
	margin-top: 130px !important;
	margin: 0 auto;
	width: 100%;
	margin-bottom: 12px;
	text-align: center;
}

.info-form {
	padding: 20px;
	border-radius: 16px;
	background-color: #001a43;
}

.form-group {
	margin-bottom: 20px;
}

.form-label {
	color: white;
	display: block;
	font-size: 32px;
	width: 150px;
	min-width: 150px;
}

.form-input {
	width: 100%;
	height: 80px;
	padding: 10px 20px;
	font-size: 30px;
	border: 1px solid #ccc;
	background-color: white;
	color: black;
}

.info-desc {
	padding: 0px 40px 20px 40px;
	font-size: 28px;
	line-height: 1.6;
	color: #333;
}

/* 동의 섹션 스타일 */
.consent-section {
	margin-bottom: 24px;
}

.consent-header {
	font-size: 22px;
	font-weight: 900;
	color: #5a3e1b;
	margin-bottom: 8px;
	letter-spacing: -1px;
}

.consent-header-icon {
	color: #5a3e1b;
	margin-right: 4px;
}

.consent-description {
	font-size: 14px;
	font-weight: bold;
	color: #222;
	line-height: 1.8;
	margin-bottom: 12px;
	letter-spacing: -0.5px;
}

.consent-table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 0;
	border-top: 3px solid #5a3e1b;
	border-bottom: 2px solid #999;
}

.consent-table th,
.consent-table td {
	padding: 12px 16px;
	text-align: left;
	border: 1px solid #bbb;
	font-size: 15px;
	font-weight: bold;
	letter-spacing: -0.5px;
	color: #222;
	white-space: pre-line;
	vertical-align: middle;
}

.consent-table th {
	background-color: #f2f2f2;
	color: #222;
	font-weight: 900;
	width: 32%;
	text-align: center;
	border-right: 1px solid #bbb;
}

.consent-table td {
	background-color: #fff;
}

/* 첫 번째 행 (수집·이용하는 자) - 갈색 헤더 */
.consent-table-header-row th {
	background-color: #7a6140;
	color: #fff;
	font-size: 15px;
	border-color: #7a6140;
}

.consent-table-header-row td {
	background-color: #f0ebe4;
	font-weight: 900;
	color: #222;
	border-color: #bbb;
}

.consent-agree-row {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 6px 0;
	gap: 48px;
}

.consent-agree-label {
	font-size: 17px;
	font-weight: 900;
	color: #5a3e1b;
	letter-spacing: -0.5px;
}

.consent-agree-options {
	display: flex;
	gap: 36px;
}

.consent-option {
	font-size: 17px;
	font-weight: bold;
	color: #333;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 6px;
}

.consent-option.active {
	font-weight: bold;
	color: #5a3e1b;
}

.consent-radio {
	font-size: 16px;
}

.next-button {
	display: block;
	width: 350px;
	height: 80px;
	background-color: #001a43;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}

/* step3 */
.content_step3 {
	height: 100vh;
	overflow: hidden;
	padding: 140px 120px 0 120px;
	background-color: #ffffff;
	color: #001a43;
}
.auth-header {
	.bold {
		font-weight: bold;
	}
	background-color: #e9eae4;
	border-radius: 16px;
	padding: 24px 48px 24px 48px;
	width: 100%;
	text-align: center;
	margin-bottom: 50px;
}

.auth-header h1 {
	font-size: 80px;
	font-weight: bold;
	color: #001a43;
	margin-bottom: 25px;
}

.auth-header p {
	font-size: 30px;
	color: black;
	line-height: 1.5;
	margin-bottom: 0px !important;
}

.auth-form {
	background-color: #001a43;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px;
}

.auth-input-container {
	padding: 0 26px;
	width: 100%;
}

#auth-input {
	width: 100%;
	height: 120px;
	background-color: #dcdedd;
	border: 1px solid #ccc;
	font-size: 50px;
	text-align: center;
	letter-spacing: 10px;
	outline: none;
	cursor: default;
	color: black;
}

.keypad {
	width: 100%;
	background-color: #001a43;
	border-radius: 10px;
	padding: 20px;
}

.keypad-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
}

.keypad-row:last-child {
	margin-bottom: 0;
}

.key {
	flex: 1;
	height: 150px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	color: #000;
	border: #000 1px solid;
	font-size: 70px;
	font-weight: bold;
	margin: 0 8px;
	cursor: pointer;
	user-select: none;
	text-align: center;
}

.clear-key {
	font-size: 40px;
	line-height: 1.2;
}

.backspace-key {
	font-size: 55px;
}

.key:active {
	background-color: #999999;
}

.action-button-container {
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 70px auto;
}
.action-button-outlined {
	width: 400px;
	height: 100px;
	background-color: white;
	color: #001a43;
	border: border 1px solid #001a43;
	border-radius: 80px;
	font-size: 64px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}
.action-button {
	width: 350px;
	height: 80px;
	background-color: #001a43;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}

.action-button:hover {
	background-color: #001a43;
}

/* step4 */
.title-container {
	text-align: center;
}

.main-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
	letter-spacing: -1px;
}

.sub-title {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 100px;
}

.schedule-table {
	width: 100%;
	max-width: 850px;
	margin: 0 auto;
	margin-bottom: 100px;
}

.schedule-table th,
.schedule-table td {
	text-align: center;
	vertical-align: middle;
	height: 140px;
	font-size: 50px;
	font-weight: bold;
}

.schedule-table th {
	background-color: #d5d5d5;
	color: #001a43;
}

.schedule-table td {
	background-color: white;
	color: #001a43;
}

.date {
	font-size: 60px;
}

.day {
	font-size: 40px;
	display: block;
	margin-bottom: 16px;
}

.button-container {
	margin: 100px 0;
}

.reservation-button {
	background-color: white;
	color: #001a43;
	padding: 4px 0;
	width: 400px;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
}
.divider-width {
	margin: 0 auto;
	max-width: 850px;
	width: 100%;
	height: 1px;
	background-color: #fff;
}
.info-block {
	width: 100%;
	max-width: 850px;
	background-color: #d5d5d5;
	color: #001a43;
	padding: 8px 0;
	text-align: center;
	font-size: 48px;
	font-weight: bold;
	margin: 0 auto;
}

.house-info {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	font-size: 57px;
}

.house-separator {
	margin: 0;
}

.contact-number {
	font-size: 120px;
	font-weight: bold;
	margin-bottom: 160px;
}
/* 개인정보 수집·이용 동의 (약관) - 기본 정보 입력 하단 */
// 섹션 제목(| 기본 정보 입력 | 등) 위 여백: 공용 130px → 80px (1080x1920 키오스크 한 화면에 맞춤, 스크롤 방지)
// scoped 라 이 화면에만 적용되고, 공용 .info-header 가 !important 라 같이 !important 사용
.info-header {
	margin-top: 80px !important;
}

// 동의 섹션이 위, 기본 정보 입력(키보드)이 아래 - 두 섹션 사이 간격
.info-section + .info-section {
	margin-top: 40px;
}
.raon-terms-title {
	font-size: 30px;
	font-weight: bold;
	color: #15243d;
	margin: 24px 0 12px;
}
.raon-terms-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 24px;
	color: #15243d;
}
.raon-terms-table th,
.raon-terms-table td {
	border: 2px solid #15243d;
	padding: 14px 18px;
	text-align: left;
	vertical-align: middle;
	line-height: 1.4;
}
.raon-terms-table th {
	width: 34%;
	background-color: #e9eae4;
	font-weight: bold;
}
// 동의 질문 + 동의 함/동의 안함을 한 줄로 고정 (키오스크 글꼴 폭 차이로 줄바꿈되던 문제)
.raon-terms-agree {
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: 18px;
	margin: 28px 0 16px;
	font-size: 26px;
	font-weight: bold;
	color: #15243d;
	white-space: nowrap;
	.terms-radio-option {
		flex: none;
	}
}
.raon-terms-q {
	margin-right: 6px;
	letter-spacing: -0.02em;
}
.raon-terms-footnotes {
	font-size: 20px;
	color: #555;
	line-height: 1.5;
}
.raon-terms-footnotes p {
	margin-bottom: 8px;
}
/* 트리븐 센텀 - 기본 인트로 (메인 이미지 미등록 시) */
.triven-intro {
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: #000e43;
	color: #ffffff;
	text-align: center;
	cursor: pointer;
}
.triven-intro-site {
	font-size: 90px;
	font-weight: 900;
}
.triven-intro-title {
	font-size: 56px;
	font-weight: 700;
	margin-top: 24px;
}
.triven-intro-desc {
	font-size: 34px;
	line-height: 1.6;
	margin-top: 60px;
	opacity: 0.9;
}
.triven-intro-btn {
	margin-top: 100px;
	padding: 28px 90px;
	border: 3px solid #ffffff;
	border-radius: 60px;
	font-size: 44px;
	font-weight: 700;
}
/* 트리븐 센텀 개인정보 약관 (스크롤 박스) */
.triven-terms-box {
	height: 520px;
	overflow-y: auto;
	border: 2px solid #15243d;
	padding: 20px 24px;
	margin-top: 24px;
	font-size: 22px;
	line-height: 1.55;
	color: #15243d;
	background: #ffffff;
}
.triven-terms-sec {
	margin-bottom: 18px;
}
.triven-terms-h {
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 6px;
}
.triven-terms-box p {
	margin-bottom: 4px;
}
.triven-terms-sub {
	font-weight: bold;
	margin-top: 8px;
}
/* 응모권 발급 안내 다이얼로그 */
.triven-result {
	background: #ffffff;
	padding: 60px 50px 50px;
	text-align: center;
	color: #15243d;
}
.triven-result-title {
	font-size: 52px;
	font-weight: 900;
}
.triven-result-info {
	font-size: 36px;
	font-weight: 700;
	margin-top: 30px;
}
.triven-result-desc {
	font-size: 30px;
	line-height: 1.6;
	margin: 30px 0 50px;
}
/* 동의 함 / 동의 안함 - 키오스크에서 누르기 쉽게 크게 */
.raon-terms-agree .terms-radio-option {
	font-size: 28px;
	padding: 8px 4px;
}
</style>
